import { ref } from 'vue';
import { defineStore } from 'pinia';

// This store is to share the drawer state between Views (posts and reqs)
export const useFilterDrawer = defineStore('filterDrawer', () => {
  const open = ref(false);

  return { open };
});
